<template>
  <div v-if="payload.freezed_until" class="is-flex is-align-items-center">
    <img @click="toggle()" src="/ice_cube.png" class="btn"  width="30px" />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'ice-freeze-icon',
  props: ['payload'],
  methods: {
    toggle () {
      this.create({
        designator: 'is-freeze-modal',
        component_name: 'FreezeApplicant',
        modal_title: `${this.payload.full_name} - freeze`,
        modal_width: 600,
        props: {
          id: this.payload.resource_id,
          freezedDate: this.payload.freezed_until
        }
      })
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
